import ProfileApis from '@/services/apis/profile'

import AuthApis from '@/services/apis/auth'

const GetDescription = () => import(`@/views/${process.env.VUE_APP_THEME_NAME}/components/getDescription.vue`)

const profile = new ProfileApis()
const auth = new AuthApis()
const actvieModules = process.env.VUE_APP_ACTIVE_MODULES.split(',')

export default {
  components: { GetDescription },
  data() {
    return {
      show: false,
      sendMaliLoading: false,
      exchangePath: process.env.VUE_APP_EXCHANGE_ADDRESS,
      exchangePage: process.env.VUE_APP_EXCHANGE_PAGE,
      isUserActive: false,
      cardsArray: [],
      mergedObj: {},
      dashboardCards: {
        document: {
          general: {
            title: 'doc.general.title',
            pendingDescription: 'doc.general.pending.desc',
            rejectDescription: 'doc.general.reject.desc',
            cardType: 'document',
            link: { name: 'document-general' },
          },
          bank: {
            title: 'doc.bank.title',
            pendingDescription: 'doc.bank.pending.desc',
            rejectDescription: 'doc.bank.reject.desc',
            cardType: 'document',
            link: { name: 'document-bank' },
          },
        },
        ...(actvieModules.includes('FOREX') && {
          forex: {
            deposit: {
              wire: {
                title: 'forex.deposit.wire.title',
                description: 'forex.deposit.wire.desc',
                link: { name: 'forexModule-bank-deposit' },
              },
              crypto: {
                title: 'forex.deposit.crypto.title',
                description: 'forex.deposit.crypto.desc',
                link: { name: 'forexModule-crypto-deposit' },
              },
            },
            withdrawal: {
              crypto: {
                title: 'forex.withdrawal.crypto.title',
                description: 'forex.withdrawal.crypto.desc',
                link: { name: 'forexModule-crypto-withdrawal' },
              },
              wire: {
                title: 'forex.withdrawal.wire.title',
                description: 'forex.withdrawal.wire.desc',
                link: { name: 'forexModule-bank-withdrawal' },
              },
            },
          },
        }),
        ...(actvieModules.includes('CRYPTO') && {
          crypto: {
            deposit: {
              wire: {
                title: 'crypto.deposit.wire.title',
                description: 'crypto.deposit.wire.desc',
                link: '/customer-wallets/fiat/deposit/online',
              },
              crypto: {
                title: 'crypto.deposit.crypto.title',
                description: 'crypto.deposit.crypto.desc',
                link: '/crypto-wallets',
              },
            },
            withdrawal: {
              wire: {
                title: 'crypto.withdrawal.wire.title',
                description: 'crypto.withdrawal.wire.desc',
                link: '/customer-wallets/fiat/withdraw',
              },
              crypto: {
                title: 'crypto.withdrawal.crypto.title',
                description: 'crypto.withdrawal.crypto.desc',
                link: '/crypto-wallets',
              },
            },
          },
        }),
      },
    }
  },

  async mounted() {
    this.show = true
    await auth.steps()
    await profile.dashboard().then(res => {
      this.mergedObj = this.mergeObjects(this.dashboardCards, res.data.results)

      this.cardsArray = this.collectLeafObjects(this.mergedObj)
    })
    this.show = false
  },
  methods: {
    mergeObjects(obj1, obj2) {
    // Create a new object to hold the merged values
      const result = {}

      // Merge properties of obj1
      // eslint-disable-next-line no-restricted-syntax
      for (const key in obj1) {
      // eslint-disable-next-line no-prototype-builtins
        if (obj1.hasOwnProperty(key)) {
          result[key] = obj1[key]
        }
      }

      // Merge properties of obj2, recursively merging any object properties
      // eslint-disable-next-line no-restricted-syntax
      for (const key in obj2) {
      // eslint-disable-next-line no-prototype-builtins
        if (obj2.hasOwnProperty(key)) {
          if (typeof obj2[key] === 'object' && obj2[key] !== null && result[key]) {
            result[key] = this.mergeObjects(result[key], obj2[key])
          } else {
            result[key] = obj2[key]
          }
        }
      }
      return result
    },
    collectLeafObjects(obj, result = []) {
      let isLeaf = true

      Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'object' && obj[key] !== null && key !== 'link') { // key !== 'link' becuse of link object
          isLeaf = false
          this.collectLeafObjects(obj[key], result)
        }
      })

      // If no properties were objects, it's a leaf object
      if (isLeaf) {
        result.push(obj)
      }

      return result
    },
  },
}
